import 'hammerjs';
import { enableProdMode, LOCALE_ID } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

export function getBaseUrl() {
  var baseUrl = document.getElementsByTagName('base')[0].href
  if (baseUrl.endsWith('/')) {
    // Remove the trailing slash
    return baseUrl.slice(0, -1);
  }

  return baseUrl; //"http://10.123.234.121:5001";
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

platformBrowserDynamic(providers).bootstrapModule(AppModule).catch(err => console.log(err));
